let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bq1O0")).then(() => parcelRequire('fttLu'));